import Vimeo from '@u-wave/react-vimeo';
import YouTubePlaylist from '@codesweetly/react-youtube-playlist';

interface VideoBoxProps {
  videoTitle?: string;
  youtubeVideoId?: string;
  vimeoVideoId?: string;
  youtubePlaylistId?: string;
}

export default function VideoBox({
  videoTitle,
  youtubeVideoId,
  vimeoVideoId,
  youtubePlaylistId,
}: VideoBoxProps) {
  return (
    <div>
      <section className="container dark-section my-8">
        <div className="w-10 mx-auto">
          {!!videoTitle && (
            <h3 className="text-center font-400">{videoTitle}</h3>
          )}
          {!!youtubeVideoId && (
            <div className="video-container px-4 mx-auto w-full">
              <iframe
                src={`https://www.youtube.com/embed/${youtubeVideoId}?rel=0&modestbranding=1`}
                width="560"
                height="315"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="video"
              />
            </div>
          )}
          {!!vimeoVideoId && <Vimeo video={vimeoVideoId} />}
          {!!youtubePlaylistId && !!process.env.REACT_APP_YOUTUBE_API && (
            <YouTubePlaylist
              apiKey={process.env.REACT_APP_YOUTUBE_API}
              playlistId={youtubePlaylistId}
              uniqueName={`${youtubePlaylistId}`}
              params={{ rel: 0, modestbranding: 1 }}
            />
          )}
        </div>
      </section>
    </div>
  );
}
